import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import AvatarTealSvg from './icon-avatar-teal.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <AvatarTealSvg {...validProps} />;
}
SvgComponent.iconName = 'avatarTeal';

/**
 * @deprecated This is a legacy icon
 */
export const AvatarTealIcon = svgIconWrapper(SvgComponent);
